"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var utils_1 = require("@doshexchnage/utils");
var react_1 = require("@iconify/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var routes_1 = require("../../../../../../../constants/routes");
var constants_1 = require("../../../constants");
function useRenderCellViews() {
    var renderCellViews = (0, react_2.useCallback)(function (entry) { return [
        {
            key: "rank",
            content: ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 text-sm font-semibold text-default-foreground", children: [constants_1.podiumColours[entry.rank] ? (0, jsx_runtime_1.jsx)(react_1.Icon, { icon: "solar:cup-star-bold", width: 18, style: { color: constants_1.podiumColours[entry.rank] } }) : null, entry.rank] })),
        },
        {
            key: "display_name",
            content: ((0, jsx_runtime_1.jsx)(react_router_dom_1.Link, { to: "".concat(routes_1.CONSOLE_ROUTE).concat(routes_1.CUSTOMERS_ROUTE, "/").concat(entry.user_id), className: "text-nowrap text-sm font-medium text-accent hover:underline", children: entry.display_name || entry.user_id })),
        },
        { key: "value", content: (0, jsx_runtime_1.jsx)("div", { className: "text-sm font-semibold text-default-foreground", children: entry.value.toLocaleString() }) },
        {
            key: "achieved_at",
            content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: entry.achieved_at ? (0, utils_1.formatDateTime)(new Date(entry.achieved_at)) : "N/A" }),
        },
    ]; }, []);
    return (0, react_2.useMemo)(function () { return ({ renderCellViews: renderCellViews }); }, [renderCellViews]);
}
